import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './ComboServiceDetail.module.scss';
import { getNumberWithCommas } from '~/utils';
import { Row, Col, Breadcrumb, Tabs, Modal, notification, Spin } from 'antd';
import Slider from 'react-slick';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import comboServiceAPI from '~/api/ComboServiceAPI';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import config from '~/config';
import CancelModal from '~/components/FormCancel';
import { addComboServiceToCartStore } from '~/store/actions/CartComboServiceAction';
import { useDispatch, useSelector } from 'react-redux';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';

const cx = classNames.bind(styles);
const { TabPane } = Tabs;

const SlideImage = styled.div`
    .SpaDetail_content_service__GKDMf .SpaDetail_image-container__Mk12S {
        width: 100% !important;
        // width: 5000px;
    }
    ul {
        bottom: -110px;
        height: 100px;
        width: auto;
    }
    .slick-dots li {
        width: 15%;
        height: 100px;
    }
    img {
        vertical-align: top;
        width: 100%;
    }
`;

const TabsContainer = styled.div`
    .ant-tabs-tab {
        font-size: 20px;
        font-weight: 600;
        color: rgba(137, 137, 137, 1);
    }
    .ant-tabs-tab.ant-tabs-tab-active {
        border-bottom: 3px solid #311d4f !important;
        z-index: 2;
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #311d4f;
    }
    .ant-tabs-bottom > .ant-tabs-nav:before,
    .ant-tabs-bottom > div > .ant-tabs-nav:before,
    .ant-tabs-top > .ant-tabs-nav:before,
    .ant-tabs-top > div > .ant-tabs-nav:before {
        border-bottom: 3px solid #e2e2e2;
    }
`;

const ComboServiceDetail = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);

    const userInfo = useSelector((state) => state.user.userInfo);
    const isLogin = userInfo?.id || '';
    // const isLogin = !!localStorage.getItem('token');
    const [isShowRequireLogin, setIsShowRequireLogin] = useState(false);

    const { combo_service_id } = useParams();

    const [count, setCount] = useState(1);

    const [serviceInfo, setServiceInfo] = useState({});

    const [activeKey, setActiveKey] = useState('1');

    const onChangeTabs = (key) => {
        setActiveKey(key);
        console.log(key);
    };

    const settings = {
        customPaging: function (index) {
            return <img src={serviceInfo?.image_list[index]} alt="" />;
        },
        dots: true,
        dotsClass: 'slick-dots slick-thumb',
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    const handleGetOneService = async () => {
        setIsLoading(true);
        try {
            let service = {};
            const params = {
                fields: '["$all",{"combo_service_item":["$all", {"service": ["$all"]}]}]',
            };
            const res = await comboServiceAPI.getOneComboServiceAPI(combo_service_id, params);

            if (res.code === 200) {
                service = { ...res.results.object };
            }

            setServiceInfo(service);
        } catch (err) {
            console.log(err);
        }
        setIsLoading(false);
    };

    const onAgreeLogin = () => {
        navigate(config.routes.login);
        setIsShowRequireLogin(false);
    };
    const onRejectLogin = () => {
        setIsShowRequireLogin(false);
    };

    useEffect(() => {
        handleGetOneService();

        //eslint-disable-next-line
    }, [combo_service_id]);
    const handleAddProductToCart = () => {
        if (isLogin) {
            serviceInfo.amount_order = count;
            const currentPrice = serviceInfo?.discount
                ? serviceInfo?.price - serviceInfo?.discount
                : serviceInfo?.price || 0;
            serviceInfo.total_price = currentPrice * serviceInfo.amount_order;
            dispatch(addComboServiceToCartStore(serviceInfo));
            notification.open({
                message: 'Product added to cart',
                duration: 2,
                placement: 'top',
            });
        } else {
            localStorage.setItem('navigateAfterLogin', `/thong-tin-san-pham/${serviceInfo?.id}`);
            setIsShowRequireLogin(true);
        }
    };

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangThongTinComboDichVu');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div>
                <Breadcrumb className={cx('breadcrumb')}>
                    <Breadcrumb.Item>Service Package</Breadcrumb.Item>
                    <Breadcrumb.Item className={cx('breadcrumItemActive')}>Service pack information</Breadcrumb.Item>
                </Breadcrumb>
            </div>
            {isLoading ? (
                <Row justify="center" align="middle" style={{ height: '500px' }}>
                    <Spin />
                </Row>
            ) : (
                <>
                    {serviceInfo?.id ? (
                        <>
                            <div className={cx('content_service')}>
                                <Row className={cx('content_service_row')}>
                                    <Col xs={24} sm={12} md={12} style={{ padding: '0px 7px' }}>
                                        {serviceInfo.image_list?.length ? (
                                            <SlideImage>
                                                <Slider {...settings}>
                                                    {serviceInfo.image_list?.map((item) => {
                                                        return (
                                                            <div className={cx('image-container')}>
                                                                <img src={item} alt="" />
                                                            </div>
                                                        );
                                                    })}
                                                </Slider>
                                            </SlideImage>
                                        ) : (
                                            <img
                                                className={cx('image_main')}
                                                src={serviceInfo.image || IMAGES.NewLogoCut}
                                                alt=""
                                            />
                                        )}
                                    </Col>
                                    <Col
                                        className={cx(
                                            serviceInfo?.image_list?.length
                                                ? 'service_detail'
                                                : 'service_detail_no_slide',
                                        )}
                                        xs={24}
                                        sm={12}
                                        md={12}
                                    >
                                        <Row className={cx('type')}>{serviceInfo?.category_name}</Row>
                                        <Row className={cx('name')}>{serviceInfo?.title}</Row>
                                        <Row align="middle" className={cx('price')}>
                                            <span className={cx('price_sale')}>
                                                {getNumberWithCommas(serviceInfo?.price - serviceInfo?.discount)} d
                                            </span>
                                            {parseInt(serviceInfo?.discount) ? (
                                                <>
                                                    <span className={cx('price_origin')}>
                                                        {getNumberWithCommas(serviceInfo?.price)} d
                                                    </span>
                                                    {Math.round((serviceInfo?.discount * 100) / serviceInfo?.price) ? (
                                                        <span className={cx('discount')}>
                                                            -
                                                            {Math.round(
                                                                (serviceInfo?.discount * 100) / serviceInfo?.price,
                                                            )}
                                                            %
                                                        </span>
                                                    ) : null}
                                                </>
                                            ) : null}
                                        </Row>
                                        <Row justify="center" className={cx('summary')}>
                                            {serviceInfo?.description}
                                        </Row>
                                        {/* <Row justify="center">
                                        <div className={cx('button')} onClick={handleNavigateBookingService}>
                                            Buy now
                                        </div>
                                    </Row> */}

                                        <div className={cx('fontsize_16px')}>Quantity</div>
                                        <Row align="middle" gutter={[30, 30]}>
                                            <Col align="middle">
                                                <Row span={8} align="middle" className={cx('border')}>
                                                    <div
                                                        className={cx(
                                                            count > 1 ? 'button_count' : 'button_count_disable',
                                                        )}
                                                        onClick={() => {
                                                            setCount(count > 1 ? count - 1 : count);
                                                        }}
                                                    >
                                                        <img src={SVGS.IconSub} alt="" />
                                                    </div>
                                                    <span className={cx('count')}>{count}</span>
                                                    <div
                                                        className={cx('button_count')}
                                                        onClick={() => {
                                                            setCount(count + 1);
                                                        }}
                                                    >
                                                        <img src={SVGS.IconPlus} alt="" />
                                                    </div>
                                                </Row>
                                            </Col>

                                            <Col>
                                                <div className={cx('button')} onClick={handleAddProductToCart}>
                                                    Add to cart
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </div>
                            <div
                                className={cx(
                                    serviceInfo.image_list?.length ? 'tabs_content' : 'tabs_content_no_slide',
                                )}
                            >
                                <TabsContainer>
                                    <Tabs defaultActiveKey={activeKey} onChange={onChangeTabs}>
                                        <TabPane tab="Services" key="1">
                                            {serviceInfo?.combo_service_item?.length ? (
                                                <Row>
                                                    {serviceInfo?.combo_service_item?.map((item) => {
                                                        return (
                                                            <Col xs={24} md={12} xl={8}>
                                                                <div className={cx('service_item_desktop')}>
                                                                    <Row justify="center">
                                                                        <div
                                                                            className={cx('service_image')}
                                                                            //   onClick={handleNavigateDetailService}
                                                                        >
                                                                            <img
                                                                                src={
                                                                                    item.service?.image ||
                                                                                    IMAGES.ImagePlaceholder
                                                                                }
                                                                                alt=""
                                                                            />
                                                                        </div>
                                                                    </Row>
                                                                    <div className={cx('service_container')}>
                                                                        <Row
                                                                            justify="center"
                                                                            className={cx('name_service')}
                                                                            //   onClick={handleNavigateDetailService}
                                                                        >
                                                                            {item.service?.title}
                                                                        </Row>
                                                                        <Row
                                                                            justify="center"
                                                                            className={cx('time_service')}
                                                                        >
                                                                            Time:
                                                                            <span>
                                                                                {item.service?.execution_time} minutes
                                                                            </span>
                                                                        </Row>
                                                                        <Row
                                                                            justify="center"
                                                                            className={cx('time_service')}
                                                                        >
                                                                            Number of uses:
                                                                            <span>{item?.amount}</span>
                                                                        </Row>
                                                                        <Row justify="center" className={cx('summary')}>
                                                                            {item.service?.description}
                                                                        </Row>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        );
                                                    })}
                                                </Row>
                                            ) : null}
                                        </TabPane>
                                        <TabPane tab="Process" key="2">
                                            {serviceInfo?.implementation_process ? (
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: serviceInfo?.implementation_process,
                                                    }}
                                                ></div>
                                            ) : (
                                                <span>No process yet!</span>
                                            )}
                                        </TabPane>
                                    </Tabs>
                                </TabsContainer>
                            </div>
                        </>
                    ) : (
                        <Row justify="center" className={cx('service_no_exist')}>
                            Service pack does not exist
                        </Row>
                    )}
                </>
            )}

            {isShowRequireLogin && (
                <Modal
                    centered
                    visible={isShowRequireLogin}
                    onCancel={() => setIsShowRequireLogin(false)}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={500}
                >
                    <div style={{ padding: '20px 20px' }}>
                        <CancelModal
                            onAgreeCancel={onAgreeLogin}
                            onRejectCancel={onRejectLogin}
                            text="Do you want to log in to continue?"
                        />
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default ComboServiceDetail;
